<template>
  <div>
    <el-dialog
      title="Şəkil seçimi"
      :visible.sync="openFileSelectionModal"
      width="70%"
      top="20vh"
      append-to-body
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="closeFileSelectionModal"
    >
      <div v-loading="loading">
        <div v-if="files && files.length">
          <el-checkbox v-model="allSelected" @change="toggleSelectAll" class="select-all-checkbox">
            <span>Bütün</span>
          </el-checkbox>
          <el-checkbox-group v-model="localSelectedFiles">
            <el-checkbox v-for="file in files" :key="file.id" :label="file">
              <img :src="file.url || ''" @click="showImage(file.url)" class="thumbnail" />
              {{ file.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="handlePublish">Dərc et</el-button>
        <el-button size="small" @click="closeFileSelectionModal">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>

    <vue-gallery-slideshow
      v-if="galleryImages && galleryImages.length && localImageModalVisible"
      :images="galleryImages"
      :index="galleryIndex"
      @close="closeGallery"
      :visible="localImageModalVisible"
    />
  </div>
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow';

export default {
  components: {
    VueGallerySlideshow
  },
  props: {
    files: {
      type: Array,
      default: () => [] 
    },
    selectedFiles: Array,
    openFileSelectionModal: Boolean,
    selectedImage: String,
    imageModalVisible: Boolean,
    loading: Boolean
  },
  data() {
    return {
      localSelectedFiles: [...this.selectedFiles],
      allSelected: false, 
      localImageModalVisible: false, 
      galleryImages: [],
      galleryIndex: 0
    };
  },
  watch: {
    files: {
      immediate: true,
      handler(newFiles) {
        this.galleryImages = (newFiles || [])
          .filter(file => file && file.url) 
          .map(file => file.url);
      }
    },
    selectedFiles(newVal) {
      this.localSelectedFiles = [...newVal];
      this.allSelected = this.localSelectedFiles.length === this.files.length;
    },
    openFileSelectionModal(newVal) {
      if (!newVal) this.localImageModalVisible = false; 
    }
  },
  methods: {
    toggleSelectAll(value) {
      if (value) {
        this.localSelectedFiles = this.files.map(file => file); 
      } else {
        this.localSelectedFiles = []; 
      }
    },
    closeFileSelectionModal() {
      this.$emit('update:openFileSelectionModal', false);
    },
    handlePublish() {
      this.$emit('update:selectedFiles', this.localSelectedFiles);
      this.$emit('publish');
    },
    showImage(url) {
      if (!url) return;
      
      const index = this.galleryImages.indexOf(url);
      if (index !== -1) {
        this.galleryIndex = index;
        this.localImageModalVisible = true;
        this.$emit('update:imageModalVisible', true);
      }
    },
    closeGallery() {
      this.localImageModalVisible = false;
      this.$emit('update:imageModalVisible', false);
    }
  }
};
</script>
<style scoped>
.thumbnail {
  width: 100px;
  height: 100px;
  cursor: pointer;
  margin-right: 5px;
  border: 1px solid #ddd;
}

.select-all-checkbox {
  margin-bottom: 10px; /* Seçim kutusunun altındaki boşluk */
}

/* Checkbox boyutunu artırmak için */
.el-checkbox {
  font-size: 18px; /* Boyutu büyütmek için font boyutunu artır */
}
</style>
